export function smoothScrollToElement(element: HTMLElement, offset = 100) {
  const top = element.getBoundingClientRect().top + window.scrollY - offset;
  window.scroll({
    top,
    left: 0,
    behavior: 'smooth',
  });
}
